import script from "./QuestionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionPage.vue?vue&type=style&index=0&id=60316e14&scoped=true&lang=css"

import exportComponent from "D:\\myworkitem2022\\customquestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60316e14"]])

export default __exports__